import { render, staticRenderFns } from "./reservation-override-modal.vue?vue&type=template&id=24958a57&"
import script from "./reservation-override-modal.vue?vue&type=script&lang=js&"
export * from "./reservation-override-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports